/**
 * Shared time wording for thread surfaces.
 *
 * A calendar date cannot separate nine drafts made the same afternoon, which
 * is exactly the list you end up scanning — auto-created drafts all share a
 * generated title, so recency is the only thing that tells them apart.
 *
 * There is no `updated_at` on a thread, only `created_at`, so "started" is
 * what this can honestly say.
 */
export const formatRelativeTime = (date: string | Date): string => {
    const then = date instanceof Date ? date : new Date(date);
    const minutes = Math.floor((Date.now() - then.getTime()) / 60000);
    if (minutes < 1) return "just now";
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days}d ago`;
    return then.toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
    });
};

/** Absolute timestamp for the title attribute, where precision is wanted. */
export const formatExactTime = (date: string | Date): string => {
    const then = date instanceof Date ? date : new Date(date);
    return then.toLocaleString(undefined, {
        dateStyle: "medium",
        timeStyle: "short",
    });
};
